let _onLogout: (() => void) | null = null;

export const registerSSELogout = (fn: () => void): void => {
  _onLogout = fn;
};

export const clearSSELogout = (): void => {
  _onLogout = null;
};

export const callSSELogout = (): void => {
  _onLogout?.();
  _onLogout = null;
};
